import React, { useEffect, useRef, useState } from "react";
import shapedevider from "../../../assets/img/icons/shape-divider.svg";
import arrowleft from "../../../assets/img/icons/arrow-left.svg";
import arrowright from "../../../assets/img/icons/arrow-right.png";
import Slider from "react-slick";
import CatCard from "../../common/CatCard";
import useFetch from "../../../hooks/useAxios";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { createSearchParams, useNavigate } from "react-router-dom";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className="outlined-icon center  ml-[24px]" onClick={onClick}>
      <img src={arrowright} />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className="outlined-icon center" onClick={onClick}>
      {" "}<img src={arrowleft} />
    </div>
  );
}
const CategoriesCarousel = () => {
  const slider1 = useRef();

  useEffect(() => {}, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    rtl:false,
    centerMode: true,
    centerPadding: '5%',
    className: "CategoriesCarousel-padding",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  const next = () => {
    slider1.current.slickNext();
  };
  const previous = () => {
    slider1.current.slickPrev();
  };
  const [catinfo, setcatinfo] = useState([]) //city //start //end //count
  const apiGetHomeInfo = useFetch({
    method: "get",
    url: "api/home/residences-types",
    noHeader: true,
    trigger: true,
    argFunc:(res)=>setcatinfo(res.data)
   
  });
 
  return (
    <div className="container">
      <div className="flex justify-between items-center ">
        <div className="title--home">
          <img src={shapedevider} />
          <h4 className="font-[700] text-[40px] text-[#292D32]">
            دســتـه بــنـدی هـا{" "}
          </h4>
          <div className="text-[20px] text-[#797D82] title--home--p">
            بهترین اقامتگاه ها را با مناسب ترین قیمت ها و امکانات رزرو کنید{" "}
          </div>
        </div>
        <div className="flex">
          <SampleNextArrow onClick={next} />
          <SamplePrevArrow onClick={previous} />
        </div>
      </div>
    <div className="mt-[60px] CategoriesCarousel">
    {!apiGetHomeInfo.loading?<Slider  ref={slider => (slider1.current = slider)} {...settings}>
       {catinfo.map (i=>  <CatCard   info={i}  />)}
       
         
      </Slider >:
      <div className="container" >
      <SkeletonTheme height={300} borderRadius={10}>
        <div className="grid grid-cols-5 gap-[20px]">
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
        
        </div>
      </SkeletonTheme>
    </div>
      }
    </div>
    </div>
  );
};

export default CategoriesCarousel;
